module.exports = __webpack_public_path__ + "img/i_third.a703484b.png";